import {
  WidgetInstance,
} from 'mobx-store/stores/customScreens/types';
import { ValidationOptionsKeys } from 'screens/addEditCustomScreen/types';
import { ValidationSchema } from '../validation.helper';

export interface Props {
  focusedWidgetData: WidgetInstance;
  focusedWidget: null | string | number;
  handleChangeData: (paramName: string, value: any) => void;
  handleMultipleChangeData: (params: {}) => void;
  removeFocusedWidget: () => void;
}


export const descriptionWidgetValidation: ValidationSchema =  {
  text: [{ validation: [ValidationOptionsKeys.REQUIRED],}],
  textColor: [{ validation: [ValidationOptionsKeys.REQUIRED],}],
}
export enum ColorPalette {
  ON_SURFACE = 'onSurface',
  PRIMARY = 'primaryText'
}